import React from 'react';
import { Switch, Tooltip } from 'antd';
import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import { useHeaderState } from '../../store/header-state';
import { useShallow } from 'zustand/shallow';

export const ThemeToggle: React.FC = () => {
  const [theme, setTheme] = useHeaderState(useShallow((state) => [state.theme, state.setTheme]));

  const handleToggle = (checked: boolean) => {
    setTheme(checked ? 'dark' : 'light');
  };

  return (
    <Tooltip title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`} placement="bottom">
      <Switch checked={theme === 'dark'} onChange={handleToggle} checkedChildren={<MoonOutlined />} unCheckedChildren={<SunOutlined />} style={{ marginRight: '12px' }} />
    </Tooltip>
  );
};
